import { takeRight } from 'lodash-es'

export const getCurrentDomain = () => takeRight(window.location.host.split('.'), 2).join('.')
